// ─── Plan utilities ────────────────────────────────────────────────────────────
// Accept a `plan` object  { type, features, limits, ranges }
// sourced from Redux: state.getCurrentUserDetails.data.subscription_plan

const normalizePlanType = (type) => {
  if (!type) return "";
  const t = type.toLowerCase().trim();
  if (t === "premium+" || t === "premium plus") return "premium+";
  if (t === "premium") return "premium";
  if (t === "basic") return "basic";
  return t;
};

const PLAN_LEVELS = {
  "basic": 1,
  "premium": 2,
  "premium+": 3,
};

export const getPlanLevel = (type) => {
  const normalized = normalizePlanType(type);
  return PLAN_LEVELS[normalized] || 0;
};

export const isPremiumPlusPlan = (plan) =>
  normalizePlanType(plan?.type) === "premium+";

export const isPremiumPlan = (plan) => {
  const t = normalizePlanType(plan?.type);
  return t === "premium" || t === "premium+";
};

export const isBasicOrAbove = (plan) =>
  !!plan; // any active plan counts as Basic+

// Maximum number of days a post can disappear — reads from the plan's disappear_days config.
// Returns null when the plan has no cap for this feature (post never forced to expire).
export const getMaxExpireDays = (plan, featureKey = "local_feed") => {
  if (!plan) return null;
  const val = plan?.disappear_days?.[featureKey];
  return val != null ? val : null;
};

// Does the plan allow a specific feature key?
export const planHasFeature = (plan, featureKey) =>
  plan?.features?.includes(featureKey) ?? false;

// Per-plan limit for a feature — null = unlimited.
export const planLimit = (plan, featureKey) =>
  plan?.limits?.[featureKey] ?? null;

// Geographic range in km for a feature — null = unlimited.
export const planRange = (plan, featureKey) =>
  plan?.ranges?.[featureKey] ?? null;

// Disappear-in-days for a feature — null = never expires.
export const planDisappearDays = (plan, featureKey) =>
  plan?.disappear_days?.[featureKey] ?? null;
